import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

export default function Hero() {
  const { t } = useLanguage();
  const RSVP_LINK = "https://forms.gle/XCwuPTigQj7faTQ58";

  return (
    <section className="relative min-h-screen w-full flex flex-col-reverse lg:flex-row bg-brand-light overflow-hidden">
      <div className="w-full lg:w-1/2 flex flex-col items-center justify-center p-12 lg:p-24 relative z-10 text-center lg:min-h-screen">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-4/5 h-[120%] border-[1px] border-brand-muted/50 rounded-t-[500px] pointer-events-none" />
        
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="relative z-10"
        >
          <div className="flex items-center justify-center gap-3 mb-8">
            <div className="h-[1px] w-12 bg-brand-accent/50" />
            <p className="text-brand-accent uppercase tracking-[0.4em] text-xs font-semibold">
              {t('hero.saveDate')}
            </p>
            <div className="h-[1px] w-12 bg-brand-accent/50" />
          </div>

          <h1 className="font-serif text-6xl md:text-8xl text-brand-dark mb-6 tracking-tight">
            Jorge <span className="text-brand-accent block my-2 italic font-light text-5xl md:text-7xl">{t('hero.and')}</span> Betsi
          </h1>

          <p className="text-brand-dark/70 text-lg md:text-xl font-light tracking-[0.2em] mb-12 uppercase">
            Cartagena, Colombia
          </p>

          <div className="flex flex-col items-center justify-center gap-2 text-brand-dark text-2xl md:text-3xl font-serif">
            <p>27 . 07 . 2027</p>
          </div>

          <a
            href={RSVP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-12 px-10 py-4 bg-brand-accent text-white uppercase tracking-[0.2em] text-xs font-bold rounded-sm hover:bg-brand-dark transition-colors duration-300"
          >
            {t('hero.rsvpNow')}
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.5 }}
          className="hidden lg:flex absolute bottom-10 left-1/2 -translate-x-1/2 flex-col items-center gap-3"
        >
          <a href="#details" className="group flex flex-col items-center gap-3">
            <span className="text-[10px] uppercase tracking-[0.4em] text-brand-dark/50 group-hover:text-brand-accent transition-colors">
              {t('hero.details')}
            </span>
            <div className="w-[1px] h-12 bg-brand-dark/20 group-hover:bg-brand-accent transition-colors" />
          </a>
        </motion.div>
      </div>

      <div className="w-full h-[60vh] lg:h-screen lg:w-1/2 relative bg-brand-muted">
        <img
          src="https://media-manager-c.questera.ai/greta-media/153fd5d2fdd20858b26a13c9932ff3217659a85e9274a7f52a0e384f0ac7c569cdee7d9b987fd74ccbb6c74cf135f0f9/images/aW1hZ2UvanBlZw==/eec20b01e73375ae713eaa43230e3d6c.JPG"
          alt="Jorge and Betsi"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-light via-transparent to-transparent lg:hidden" />
      </div>
    </section>
  );
}